import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const SearchLine = ({ width = 16, height = 16, fill = '#1D2225', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.64205 11.2814C5.34577 11.2814 4.248 10.8319 3.34872 9.93305C2.44957 9.03404 2 7.93659 2 6.64069C2 5.34479 2.44957 4.24734 3.34872 3.34833C4.248 2.44944 5.34577 2 6.64205 2C7.93833 2 9.03611 2.44944 9.93539 3.34833C10.8345 4.24734 11.2841 5.34479 11.2841 6.64069C11.2841 7.18265 11.1931 7.70026 11.0112 8.19353C10.8292 8.6868 10.5863 9.11581 10.2827 9.48058L13.8386 13.0355C13.9437 13.1405 13.9975 13.2725 13.9999 13.4316C14.0023 13.5907 13.9486 13.7252 13.8386 13.8351C13.7287 13.945 13.5953 14 13.4386 14C13.2819 14 13.1487 13.945 13.0387 13.8351L9.48278 10.2802C9.10323 10.5935 8.66675 10.8387 8.17334 11.0158C7.67993 11.1928 7.1695 11.2814 6.64205 11.2814ZM6.64205 10.1433C7.62015 10.1433 8.44857 9.80392 9.12733 9.12524C9.80621 8.44668 10.1457 7.6185 10.1457 6.64069C10.1457 5.66288 9.80621 4.8347 9.12733 4.15614C8.44857 3.47746 7.62015 3.13812 6.64205 3.13812C5.66396 3.13812 4.83553 3.47746 4.15678 4.15614C3.47789 4.8347 3.13845 5.66288 3.13845 6.64069C3.13845 7.6185 3.47789 8.44668 4.15678 9.12524C4.83553 9.80392 5.66396 10.1433 6.64205 10.1433Z"
        fill={fill}
      />
    </Svg>
  );
};

export default SearchLine;
